export const partySections = [
  {
    label: '党群机构',
    path: '/organizations',
    moduleCode: 'party_organizations',
    icon: 'account_tree',
    subtitle: '党群组织架构与联系方式',
    layout: 'list',
    categories: ['党群工作处', '党支部委员会', '工会', '共青团委员会'],
    children: [
      { label: '党群工作处', path: '/organizations/work-office', category: '党群工作处', moduleCode: 'party_org_work_office', layout: 'list' },
      { label: '党支部委员会', path: '/organizations/party-branch', category: '党支部委员会', moduleCode: 'party_org_branch', layout: 'list' },
      { label: '工会', path: '/organizations/union', category: '工会', moduleCode: 'party_org_union', layout: 'list' },
      { label: '共青团委员会', path: '/organizations/youth-league', category: '共青团委员会', moduleCode: 'party_org_youth', layout: 'list' }
    ]
  },
  {
    label: '党委纪委',
    path: '/committees',
    moduleCode: 'party_committees',
    icon: 'verified_user',
    subtitle: '党委纪委工作职责与动态',
    layout: 'list',
    categories: ['党委履职', '纪委监督', '党风廉政']
  },
  {
    label: '党建专题',
    path: '/special-topics',
    moduleCode: 'party_topics',
    icon: 'topic',
    subtitle: '专题学习与主题教育',
    layout: 'topics'
  },
  {
    label: '党建工作',
    path: '/work',
    moduleCode: 'party_work',
    icon: 'work',
    subtitle: '党建工作部署与落实情况',
    layout: 'list',
    categories: ['年度要点', '阶段任务', '专项整治', '责任制']
  },
  {
    label: '组织生活',
    path: '/activities',
    moduleCode: 'party_activities',
    icon: 'groups',
    subtitle: '组织生活开展情况与记录',
    layout: 'list',
    categories: ['换届选举', '三会一课', '主题党日', '组织生活会', '中心组学习', '民主生活会', '民主评议党员', '各类党组织活动'],
    children: [
      { label: '换届选举', path: '/activities/election', category: '换届选举', moduleCode: 'party_act_election', layout: 'list' },
      { label: '三会一课', path: '/activities/three-meetings', category: '三会一课', moduleCode: 'party_act_three_meetings', layout: 'list' },
      { label: '主题党日', path: '/activities/theme-day', category: '主题党日', moduleCode: 'party_act_theme_day', layout: 'list' },
      { label: '组织生活会', path: '/activities/org-life-meeting', category: '组织生活会', moduleCode: 'party_act_org_life', layout: 'list' },
      { label: '中心组学习', path: '/activities/center-study', category: '中心组学习', moduleCode: 'party_act_center_study', layout: 'list' },
      { label: '民主生活会', path: '/activities/democratic-life', category: '民主生活会', moduleCode: 'party_act_democratic_life', layout: 'list' },
      { label: '民主评议党员', path: '/activities/member-review', category: '民主评议党员', moduleCode: 'party_act_member_review', layout: 'list' },
      { label: '各类党组织活动', path: '/activities/events', category: '各类党组织活动', moduleCode: 'party_act_events', layout: 'list' }
    ]
  },
  {
    label: '党员队伍建设',
    path: '/team-building',
    moduleCode: 'party_team',
    icon: 'person_add',
    subtitle: '党员发展、教育、管理、服务与党费管理规范',
    layout: 'list',
    categories: ['党员队伍概况', '发展党员', '党员教育', '党员管理', '党员服务', '党员奖惩', '党费管理'],
    children: [
      { label: '党员队伍概况', path: '/team-building/overview', category: '党员队伍概况', moduleCode: 'party_team_overview', layout: 'list' },
      { label: '发展党员', path: '/team-building/development', category: '发展党员', moduleCode: 'party_team_development', layout: 'list' },
      { label: '党员教育', path: '/team-building/education', category: '党员教育', moduleCode: 'party_team_education', layout: 'list' },
      { label: '党员管理', path: '/team-building/management', category: '党员管理', moduleCode: 'party_team_management', layout: 'list' },
      { label: '党员服务', path: '/team-building/service', category: '党员服务', moduleCode: 'party_team_service', layout: 'list' },
      { label: '党员奖惩', path: '/team-building/rewards', category: '党员奖惩', moduleCode: 'party_team_rewards', layout: 'list' },
      { label: '党费管理', path: '/team-building/dues', category: '党费管理', moduleCode: 'party_team_dues', layout: 'list' }
    ]
  },
  {
    label: '通知公告',
    path: '/announcements',
    moduleCode: 'party_announcement',
    icon: 'campaign',
    subtitle: '及时发布党建通知与重要公告',
    layout: 'list',
    categories: ['上级批示', '巡视巡察', '党内选举', '党务通知', '公示']
  },
  {
    label: '工作动态',
    path: '/dynamics',
    moduleCode: 'party_dynamics',
    icon: 'vital_signs',
    subtitle: '党建工作动态速递',
    layout: 'cards'
  },
  {
    label: '理论学习专栏',
    path: '/theory-study',
    moduleCode: 'party_theory',
    icon: 'menu_book',
    subtitle: '理论武装与学习资料',
    layout: 'theory',
    categories: ['权威学习库', '党内法规', '基础党务']
  },
  {
    label: '先进典型',
    path: '/exemplars',
    moduleCode: 'party_exemplars',
    icon: 'military_tech',
    subtitle: '先进典型事迹展示',
    layout: 'cards',
    categories: ['科学家精神', '重大荣誉']
  },
  {
    label: '违法违纪举报',
    path: '/reporting',
    moduleCode: 'party_reporting',
    icon: 'shield',
    subtitle: '违法违纪问题举报入口',
    layout: 'reporting'
  },
  {
    label: '下载中心',
    path: '/downloads',
    moduleCode: 'downloads',
    icon: 'download',
    subtitle: '党建相关资料下载',
    layout: 'downloads'
  }
]

export function findPartySectionByPath(path) {
  for (const section of partySections) {
    if (section.children) {
      for (const child of section.children) {
        if (child.path === path) {
          return { section, child }
        }
      }
    }
  }

  for (const section of partySections) {
    if (section.path === path) {
      return { section, child: null }
    }
  }

  const specialTopicsMatch = path.match(/^\/special-topics\/[^/]+$/)
  if (specialTopicsMatch) {
    const section = partySections.find(s => s.path === '/special-topics')
    if (section) {
      return { section, child: null }
    }
  }

  return { section: null, child: null }
}

export function flattenPartyColumnCodes() {
  const codes = []
  for (const section of partySections) {
    codes.push(section.moduleCode)
    if (section.children) {
      for (const child of section.children) {
        codes.push(child.moduleCode)
      }
    }
  }
  return codes
}
